import type { FontFamily } from 'packages/types/fonts';
import { gatewayClient, createService } from './connectors/httpClient';

const httpClient = gatewayClient('/api/v1/studio/fonts');

const fontsService = createService(httpClient, (client) => ({
    getFonts() {
        return client.get<FontFamily[]>('/list');
    },
}));

export default fontsService;
